<template>
    <div>
        <div class="kgr-postfix kgr-text kgr-text--small kgr-row">
            <p
                class="kgr-postfix__fluid"
            >
                {{ introText }}
            </p>
            <a
                class="kgr-postfix__fixed kgr-link"
                @click="showOverview = true"
            >{{ $t('child_contract_status.show_overview') }}</a>
        </div>
        <kgr-lightbox
            v-model="showOverview"
            :headline="$t('child_contract_status.overview_headline')"
            animated
        >
            <kgr-child-status-overview />
        </kgr-lightbox>

        <kgr-child-timeline
            :transitions="currentTransitions"
            :child-id="childId"
            :reload="reload"
            edit-mode
        />
    </div>
</template>

<script>
import ChildStatusOverview from './ChildStatusOverview.vue';
import ChildTimeline from './ChildTimeline.vue';
import Lightbox from '../../common/modal/Lightbox.vue';
import moment from 'moment';

export default {
    components: {
        'kgr-child-status-overview': ChildStatusOverview,
        'kgr-child-timeline': ChildTimeline,
        'kgr-lightbox': Lightbox,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
        childFullName: {
            type: String,
            required: true,
        },
        transitions: {
            type: Array,
            required: true,
        },
        reload: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            currentTransitions: [...this.transitions],
            currentStatus: '',
            now: moment(),
            showOverview: false,
        }
    },
    computed: {
        introText() {
            return this.$t('child_contract_status.intro', {
                'fullName': this.childFullName,
                'date': this.now.format('DD.MM.YYYY'),
                'status': this.$t('child_contract_status.' + this.currentStatus)
            }) + ':';
        },
    },
    watch: {
        transitions: {
            immediate: true,
            deep: true,
            handler() {
                this.currentTransitions = [...this.transitions];
                this.currentStatus = 'created';

                this.transitions.forEach(transition => {
                    if (this.now > transition.date) {
                        this.currentStatus = transition.targetStatus;
                    }
                });
            },
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
